/** Допускает только интовое число в виде строки */
export var guardInt = function guardInt(value) {
  return value.replace(/[^0-9]/g, '');
};